import { createAction } from '@ngrx/store';
import { Action } from '@ngrx/store';
export const site = '[header Component] assetsActions';
export const walktest = '[walktest Component] walktestActions'
export const walktestSettings = '[walktest Component] walktestSettings'
export const deviceStatus = '[walktest Component] deviceSetting'
export const ongoingTest = '[walktest Component] ongoingTest'
export const walktestDisableOptions = '[walktest Component] disable'
export const walktestTestMap = '[walktest Component] testmap'
export const launchTestString = '[walktest Component] launchtest'
export const reloadingActions = '[all pages] reload'
export const userData = '[actions] users'
export const openDeviceDataString = '[walktest_asset] device'


export class reloadActionsData implements Action{
  readonly type: string=reloadingActions;
  reload={};
  constructor(public data){
console.log("Action")
  }
  
}

export class deviceDetailsActions implements Action{
  type: string=openDeviceDataString;
  openPopup=false;
  constructor(public data){
    console.log("Action1")
  }
}
export class userActions implements Action {
  readonly type: string=userData;
  constructor(public data){
    console.log("Action2")
  }
}

export class assetsActions implements Action {
  readonly type = site;
  addDevice = false;
  constructor(public data) {
    console.log("Action3")
  }
}
export class deviceStatusInfo implements Action {
  readonly type = site;
  opePopUp = false;
  constructor(public data) {
  }
}
export class assetsSetWifi implements Action {
  readonly type = site;
  setWifi = false;
  constructor(public data) {
    console.log("Action4")
  }
}
export class assetsadvnceConfig implements Action {
  readonly type = site;
  advnceConfig = false;
  constructor(public data) {
    // console.log("Action4")
  }
}

export class assetsCommandPrompt implements Action {
  readonly type = site;
  setPrompt = false;
  constructor(public data) {
    console.log("Action5")
  }
}

export class assetsReboot implements Action {
  readonly type = site;
  reboot = false;
  constructor(public data) {
    console.log("Action6")
  }
}
export class assetsSetApn implements Action {
  readonly type = site;
  setApn = false;
  constructor(public data) {
    console.log("Action7")
  }
}
export class assetsDelete implements Action {
  readonly type = site;
  delete = false;
  constructor(public data) {
    console.log("Action8")
  }
}
export class assetsUpgrade implements Action {
  readonly type = site;
  upgrade = false;
  constructor(public data) {
    console.log("Action9")
  }
}
export class adminStatus implements Action {
  readonly type = site;
  adminStatus = false;
  modeStatus = false;
  constructor(public data) {
    console.log("Action10")
  }
}

export class telemetryPopupAction implements Action {
  readonly type = site;
  telemetryPopup = false;
  telemetryData: { enabled: "false", interval: 0 };
  constructor(public data) {
    console.log("Action11")

  }
}
export class gpsReportAction implements Action {
  readonly type = site;
  loadReport = false;
  constructor(public data) {

  }
}
export class walktestActions implements Action {
  readonly type = walktest;
  showStartTest = false;
  constructor(public data) {console.log("Action12") }
}

export class walktestSettingsAction implements Action {
  readonly type = walktestSettings;
  showStartTest = false;
  showStopTest = false
  showDeviceStatus = false
  constructor(public data) {console.log("Action13") }
}
export class walktestOpenDeviceStatus implements Action {
  readonly type = deviceStatus;
  showDeviceStatus = false
  showOngoingTests = false
  constructor(public data) {console.log("Action14") }
}

export class disableActionsAction implements Action {
  type = walktestDisableOptions
  disableActions = false
  constructor(public data) { console.log("Action15")}
}

export class selctMapOnLiveAction implements Action{
  type = walktestTestMap
  mapname = undefined
  constructor(private data){console.log("Action16")}
}

export class launchTestAction implements Action{
  type = launchTestString;
  launchData={}
  constructor(private data){console.log("Action17")}
}

   


export type Actions = assetsActions | deviceStatusInfo | assetsSetWifi | assetsadvnceConfig | assetsReboot | assetsSetApn | assetsDelete |assetsUpgrade|adminStatus|telemetryPopupAction|walktestActions|walktestSettingsAction|disableActionsAction|selctMapOnLiveAction | gpsReportAction;

